<template>
  <div>
    <p class="cm-mg-p-wzd">2. {{ $t('production.defects_info') }}</p>
    <hr />
    <div class="px-3">
      <div class="row sticky-button">
        <div class="col-12 col-sm-7 col-md-5 col-lg-5 px-0 mb-3">
          <div class="form-group has-label">
            <minus-plus
              :label="`${$t('production.defects_number')}: *`"
              @handlePlus="handlePlus"
              @handleMinus="handleMinus"
              :value="model.defect_quantity"
            />
          </div>
        </div>
      </div>
      <div
        v-for="(_, index) in model.defect_quantity"
        :key="index"
        class="px-3"
      >
        <div class="row">
          <div
            class="row py-3 mb-4 shadow-sm col-11"
            style="border: 0.5px solid #6ba6524d"
          >
            <div class="col-12 col-sm-4 col-lg-2">
              <fg-input
                type="number"
                min="1"
                max="10000"
                :label="`${$t('common_words.order')}: `"
                v-model="model.defect_order[index]"
                :name="`common_words.order_${index}`"
                v-validate="modelValidations.defect_order"
                :error="getFieldErrorByIndex('common_words.order', true, index)"
              ></fg-input>
            </div>
            <div class="col-12 col-sm-8 col-lg-5">
              <fg-input
                :label="`${$t('production.defect')} ${index + 1}: *`"
                class="required-name"
                ref="name"
                type="text"
                v-model="model.defect_name[index]"
                :name="`production.defect_${index}`"
                v-validate="modelValidations.defect_name"
                :error="getFieldErrorByIndex('production.defect', true, index)"
                placeholder="..."
              ></fg-input>
            </div>
            <div class="col-12 col-sm-8 col-lg-3">
              <fg-input
                type="text"
                :label="`${$t('common_words.abbreviation')}: `"
                v-model="model.defect_abbreviature[index]"
                :name="`common_words.abbreviation_${index}`"
                v-validate="modelValidations.defect_abbreviature"
                :error="
                  getFieldErrorByIndex('common_words.abbreviation', true, index)
                "
                placeholder="..."
              >
              </fg-input>
            </div>
            <div class="col-12 col-sm-4 col-lg-2">
              <div class="form-group has-label">
                <label>{{ $t('common_words.deductible') }}</label>
                <el-switch
                  v-model="model.defect_deductible[index]"
                  style="display: block; margin-top: 0.5rem"
                  active-color="#6BA652"
                  inactive-color="#ff4949"
                >
                </el-switch>
              </div>
            </div>
          </div>
          <div
            class="col-2 col-sm-4 col-lg-1 d-flex justify-content-center align-items-center"
          >
            <button
              class="btn btn-info custom-shadow-btn"
              @click="handleMinus(index)"
            >
              <em class="fa fa-minus"></em>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { isset } from 'src/util/Util';
import { MixinExport } from 'src/mixins/mixin-export';
import MinusPlus from 'src/components/Forms/MinusPlus.vue';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  components: {
    [MinusPlus.name]: MinusPlus,
  },
  data() {
    return {
      model: {
        defect_order: [1],
        defect_name: [''],
        defect_abbreviature: [''],
        defect_deductible: [true],
        defect_quantity: 1,
      },
      modelValidations: {
        defect_order: {
          required: false,
          min_value: 1,
          max_value: 10000,
        },
        defect_name: {
          required: true,
        },
        defect_abbreviature: {
          required: false,
        },
      },
    };
  },
  mixins: [MixinPermissions, MixinExport, MixinForm, MixinValidations],
  methods: {
    handlePlus() {
      this.model.defect_quantity++;
      const index = this.model.defect_quantity;
      this.model.defect_order[index - 1] = index;
      this.model.defect_name[index - 1] = '';
      this.model.defect_abbreviature[index - 1] = '';
      this.model.defect_deductible[index - 1] = true;
      this.handleNumberChange();
    },
    handleMinus(index = null) {
      if (this.model.defect_quantity > 1) {
        if (index !== null) {
          // Eliminar el registro específico
          this.model.defect_order.splice(index, 1);
          this.model.defect_name.splice(index, 1);
          this.model.defect_abbreviature.splice(index, 1);
          this.model.defect_deductible.splice(index, 1);

          this.model.defect_quantity--;
        } else {
          // Eliminar el último
          this.model.defect_quantity--;
          this.handleNumberChange();
        }
      }
    },
    handleNumberChange() {
      const fields = [
        'defect_order',
        'defect_name',
        'defect_abbreviature',
        'defect_deductible',
      ];

      fields.forEach((field) => {
        const values = [...(this.model[field] || [])];
        this.$set(
          this.model,
          field,
          values.slice(0, this.model.defect_quantity)
        );
      });
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        for (let i = 0; i < this.model.defect_quantity; i++) {
          if (!isset(this.model.defect_name[i])) {
            return this.validationInputsRequired('name');
          } else {
            this.$emit('on-validated', this.model);

            return res;
          }
        }
      });
    },
  },
  mounted() {
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));

      const { subgroups } = editForm;
      this.model = {
        isEdit: true,
        defect_order: [],
        defect_name: [],
        defect_abbreviature: [],
        defect_deductible: [],
        defect_quantity: subgroups.length,
      };

      subgroups.forEach(
        ({ order, name, abreviature, discountable, deleted_at }) => {
          if (!deleted_at) {
            this.model.defect_order.push(order);
            this.model.defect_name.push(name);
            this.model.defect_abbreviature.push(abreviature);
            this.model.defect_deductible.push(discountable);
          }
        }
      );
    }
  },
};
</script>
